<template>
    <div class="form">
        <section class="form-section">
            <div class="form-row">
                <div class="form-row__col">
                    <alert type="info">
                        {{ trans('mail_reminder_configs.alert.keep_empty') }}
                    </alert>
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('mail_reminder_configs.headline.general_settings') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.activated"
                        name="activated"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                            {value: '', label:trans('mail_reminder_configs.actions.like_parent_configuration')}
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.activated') }}
                    </form-selectbox>
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('mail_reminder_configs.headline.reminder_function') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="delay"
                        type="number"
                        min="0"
                        step="1"
                        v-model="fields.delay"
                    >
                        {{ trans('mail_reminder_configs.label.delay') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="reminder_interval"
                        type="number"
                        min="0"
                        step="1"
                        v-model="fields.reminderInterval"
                    >
                        {{ trans('mail_reminder_configs.label.reminder_interval') }}
                    </form-input>
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('mail_reminder_configs.headline.reporting_to_superiors') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.includeSubclient"
                        name="include_subclient"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.include_subclient') }}
                    </form-selectbox>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.deactivateReportingForSubclients"
                        name="deactivate_reporting_for_subclients"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.not_deactivated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                            {value: '', label:trans('mail_reminder_configs.actions.deactivated_only_if_no_own_configuration_exists')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.deactivate_reporting_for_subclients') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.reportingDay"
                        name="reporting_day"
                        :options="[
                            {value: 'monday', label:trans('mail_reminder_configs.actions.reporting_day.monday')},
                            {value: 'first_of_month', label:trans('mail_reminder_configs.actions.reporting_day.first_of_month')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.reporting_day') }}
                    </form-selectbox>
                </div>
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.attachUserlist"
                        name="attach_userlist"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                            {value: '', label:trans('mail_reminder_configs.actions.like_parent_configuration')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.attach_userlist') }}
                    </form-selectbox>
                </div>
            </div>
        </section>


        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('mail_reminder_configs.headline.reporting_receiver_settings') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.reportToAdmin"
                        name="report_to_admin"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                            {value: '', label:trans('mail_reminder_configs.actions.like_parent_configuration')}
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.report_to_admin') }}
                    </form-selectbox>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.reportToController"
                        name="report_to_controller"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                            {value: '', label:trans('mail_reminder_configs.actions.like_parent_configuration')}
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.report_to_controller') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label">{{ trans('mail_reminder_configs.label.selected_controller') }}</label>

                    <v-select
                        :options="controllerSelectOptions"
                        v-model="fields.mutatedSelectedController"
                        class="form-vue-select form-vue-select--multiple"
                        taggable multiple
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input type="hidden" name="selected_controller" :value="getSelecedController">
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('mail_reminder_configs.headline.mailing_settings') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="reminder_mail_subject"
                        v-model="fields.reminderMailSubject"
                    >
                        {{ trans('mail_reminder_configs.label.reminder_mail_subject') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.reminderMailStandard"
                        name="use_standard_layout_reminder_mail"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.use_standard_layout') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.reminderMailContent"
                        name="reminder_mail_content"
                        :rows="10"
                    >
                        {{ trans('mail_reminder_configs.label.reminder_mail_content') }}
                    </form-text-area>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="reminder_overdue_mail_subject"
                        v-model="fields.reminderOverdueMailSubject"
                    >
                        {{ trans('mail_reminder_configs.label.reminder_overdue_mail_subject') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        name="use_standard_layout_reminder_overdue_mail"
                        v-model="fields.reminderOverdueMailStandard"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.use_standard_layout') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.reminderOverdueMailContent"
                        name="reminder_overdue_mail_content"
                        :rows="10"
                    >
                        {{ trans('mail_reminder_configs.label.reminder_overdue_mail_content') }}
                    </form-text-area>
                </div>
            </div>


            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="controller_mail_subject"
                        v-model="fields.controllerMailSubject"
                    >
                        {{ trans('mail_reminder_configs.label.controller_mail_subject') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        name="use_standard_layout_controller_mail"
                        v-model="fields.controllerMailStandard"
                        :options="[
                            {value: 1, label:trans('mail_reminder_configs.actions.activated')},
                            {value: 0, label:trans('mail_reminder_configs.actions.deactivated')},
                        ]"
                    >
                        {{ trans('mail_reminder_configs.label.use_standard_layout') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.controllerMailContent"
                        name="controller_mail_content"
                        :rows="10"
                    >
                        {{ trans('mail_reminder_configs.label.controller_mail_content') }}
                    </form-text-area>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'mail_reminder_config' : {
                type: Object,
                default: () => { return {} }
            },
            'controllers': {
                type: Array
            },
            'settings': {
                type: Object,
                default: () => { return {} }
            },
            'selectedController': {
                type: Array
            },
        },

        data() {
            return {
                fields: {
                    activated: this.old('activated', this.mail_reminder_config.activated),
                    reportingDay: this.old('reporting_day', this.mail_reminder_config.reporting_day || 'monday'),
                    attachUserlist: this.old('attach_userlist', this.mail_reminder_config.attach_userlist),
                    deactivateReportingForSubclients: this.old('include_subclient', this.mail_reminder_config.deactivate_reporting_for_subclients),
                    delay: this.old('delay', this.mail_reminder_config.delay || 3),
                    reminderInterval: this.old('reminder_interval', this.mail_reminder_config.reminder_interval || 1),
                    includeSubclient: this.old('include_subclient', this.mail_reminder_config.include_subclient || 0),
                    reportToAdmin: this.old('report_to_admin', this.mail_reminder_config.report_to_admin),
                    reportToController: this.old('report_to_controller', this.mail_reminder_config.report_to_controller),

                    mutatedSelectedController: this.mutation(this.selectedController),

                    reminderMailSubject: this.old('reminder_mail_subject', this.mail_reminder_config.reminder_mail_subject),
                    reminderMailStandard: this.old('reminder_mail_standard', this.settings.reminder_mail_standard ? 1 : 0 || 0),
                    reminderMailContent: this.old('reminder_mail_content', this.settings.reminder_mail_content),
                    reminderOverdueMailSubject:this.old('reminder_overdue_mail_subject', this.mail_reminder_config.reminder_overdue_mail_subject),
                    reminderOverdueMailStandard: this.old('reminder_overdue_mail_standard', this.settings.reminder_overdue_mail_standard ? 1 : 0 || 0),
                    reminderOverdueMailContent: this.old('reminder_overdue_mail_content', this.settings.reminder_overdue_mail_content),
                    controllerMailSubject:this.old('controller_mail_subject', this.mail_reminder_config.controller_mail_subject),
                    controllerMailStandard: this.old('controller_mail_standard', this.settings.controller_mail_standard ? 1 : 0 || 0),
                    controllerMailContent: this.old('controller_mail_content', this.settings.controller_mail_content),
                }
            }
        },

        computed: {
            // Collect all selected controllers, mutated them into array
            // So that they can be sent by the request in the hideen input
            getSelecedController: function () {
                var f = [];
                if (this.fields.mutatedSelectedController) {
                    for (var v of this.fields.mutatedSelectedController) {
                        if (v) {
                            f.push(v.value)
                        }
                    }
                }

                return (f.length === 0) ? null:JSON.stringify(f);
            },

            controllerSelectOptions() {
                var temp = this.controllers.map(controller => {
                    return {label: controller.full_name, value: controller.id};
                });
                return temp;
            },
        },

        methods: {
            // init selected controllers
            mutation(controllers) {
                if (controllers === undefined || controllers.length === 0) {
                    return [];
                }

                var temp = controllers.map(controller => {
                    return {label: controller.full_name, value: controller.id};
                });
                return temp;
            }
        },
    }
</script>
